import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom email validator based on RFC 5321/5322 safe subset.
 * Enforces:
 *  - Max 254 characters total
 *  - Max 64 characters before @
 *  - Provider-safe characters (A-Z, a-z, 0-9, ., _, %, +, -)
 */
export function emailValidator(): ValidatorFn {
  const regex = new RegExp(
    /^(?=.{1,254}$)(?=.{1,64}@)(?:"(?:(?:\\[\x00-\x7F])|[^"\\\r\n])*"|(?!\.)(?!.*\.\.)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*)@(?:(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,63}|\[(?:(?:25[0-5]|2[0-4]\d|1?\d?\d)(?:\.(?:25[0-5]|2[0-4]\d|1?\d?\d)){3}|IPv6:[0-9A-Fa-f:.]+)\])$/
  );

  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null; // don't validate empty value here (use Validators.required separately)
    }

    return regex.test(value) ? null : { invalidEmailSyntax: true };
  };
}
